import merge from 'lodash/merge';
import queryPolicies from './query.policies';
import feedbackPolicies from './feedback.policies';
import mediaPolicies from './media.policies';
import companyPolicies from './company.policies';
import productPolicies from './product.policies';
import versionPolicies from './version.policies';
import impactClaimPolicies from './impactClaim.policies';
import documentsPolicies from './document.policies';
import sitePolicies, { possibleSiteTypes } from './site.policies';
import datasetPolicies from './dataset.policies';
import { devTypePolicies } from '../dev.helper';
import activityPolicies from './activity.policies';

export const possibleTypes = merge(possibleSiteTypes);

export const typePolicies = merge(
  queryPolicies,
  mediaPolicies,
  feedbackPolicies,
  companyPolicies,
  productPolicies,
  versionPolicies,
  impactClaimPolicies,
  documentsPolicies,
  activityPolicies,
  sitePolicies,
  datasetPolicies,
  ...(process.env.NODE_ENV === 'development' ? [devTypePolicies] : [])
);
